import React from "react";
import { Circle, Path, Svg } from "react-native-svg";

export interface PhoneBadgeIconProps {
  size?: number;
  bgColor?: string;
  iconColor?: string;
}

export const PhoneBadgeIcon: React.FC<PhoneBadgeIconProps> = ({
  size = 44,
  bgColor = "#fff",
  iconColor = "#333",
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 44 44"
    fill="none"
    // box-shadow: 0px 0px 25px 0px #40404040 (elevation is Android's nearest
    // equivalent — its shadow model doesn't take a blur radius directly).
    style={{
      borderRadius: size / 2,
      shadowColor: "#404040",
      shadowOffset: { width: 0, height: 0 },
      shadowOpacity: 0.25,
      shadowRadius: 25,
      elevation: 12,
    }}
  >
    <Circle cx={22} cy={22} r={22} fill={bgColor} />
    <Path
      stroke={iconColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M23.527 25.808a.833.833 0 0 0 1.01-.252l.297-.388a1.666 1.666 0 0 1 1.333-.667h2.5a1.667 1.667 0 0 1 1.667 1.667v2.5a1.667 1.667 0 0 1-1.667 1.667 15 15 0 0 1-15-15 1.667 1.667 0 0 1 1.667-1.667h2.5a1.667 1.667 0 0 1 1.666 1.667v2.5a1.667 1.667 0 0 1-.666 1.333l-.39.293a.833.833 0 0 0-.244 1.027 11.667 11.667 0 0 0 5.327 5.32Z"
    />
  </Svg>
);

export default PhoneBadgeIcon;
